module.exports = __webpack_public_path__ + "img/island.be5030ca.webp";